import { render, staticRenderFns } from "./SynaqLicences.vue?vue&type=template&id=f9dced6a&scoped=true&"
import script from "./SynaqLicences.vue?vue&type=script&lang=js&"
export * from "./SynaqLicences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dced6a",
  null
  
)

export default component.exports